import { IFormOption } from '../data/utils/form';

export function formOption<T extends string>(value: T, label: string = value): IFormOption<T> {
    return { value, label };
}
